import {
  AccountBookOutlined,
  BankOutlined,
  CalendarOutlined,
  ContainerOutlined,
  EnvironmentOutlined,
  FileTextOutlined,
  IdcardOutlined,
  SolutionOutlined,
  StopOutlined,
  TeamOutlined,
} from "@ant-design/icons";

/**
 * The sections of the final check, in the order of the review feed. `what(target, n)` is the
 * one-sentence « Ce qui se passe ici » in plain words (`n`: the section's record count, except for
 * « Établissements » where the caller passes the number of sources); `noun` counts the section's records.
 */
export const SECTIONS = [
  {
    key: "institutions",
    label: "Établissements",
    icon: BankOutlined,
    noun: ["fiche", "fiches"],
    // `n` = the archived establishments (the sources) — never the section total, which also counts the result
    what: (t, n) =>
      `${
        n > 1
          ? `les ${n} établissements sont archivés et tout ce qu'ils contiennent part`
          : "l'établissement est archivé et tout ce qu'il contient part"
      } vers ${t}. La fiche de ${t} est montrée champ par champ, avec l'origine de chaque valeur.`,
  },
  {
    key: "accounts",
    label: "Comptes utilisateurs",
    icon: TeamOutlined,
    noun: ["compte", "comptes"],
    what: t =>
      `chaque compte suit son établissement : son lien est remplacé par ${t}. Une même personne présente sur deux établissements n'a plus qu'un seul compte.`,
  },
  {
    key: "addresses",
    label: "Adresses",
    icon: EnvironmentOutlined,
    noun: ["adresse", "adresses"],
    what: t =>
      `chaque adresse est rattachée à ${t}. Les adresses en double deviennent une seule adresse et vos corrections sont appliquées.`,
  },
  {
    key: "responsables",
    label: "Responsables",
    icon: IdcardOutlined,
    noun: ["responsable", "responsables"],
    what: t =>
      `chaque responsable est rattaché à ${t}. Les responsables en double deviennent un seul et vos corrections sont appliquées.`,
  },
  {
    key: "blacklists",
    label: "Listes noires d'interprètes",
    icon: StopOutlined,
    noun: ["interprète", "interprètes"],
    what: t =>
      `un interprète exclu par un ancien établissement — ou par ${t} elle-même quand elle existe déjà — reste exclu de ${t} (exclusion gardée) ou ne l'est plus (exclusion retirée), selon votre choix. Les exclusions chez des institutions hors fusion ne changent pas.`,
  },
  {
    key: "prestations",
    label: "Prestations",
    icon: SolutionOutlined,
    noun: ["prestation", "prestations"],
    records: true,
    what: t =>
      `chaque prestation reste la même ; seul son établissement change : l'identifiant de l'ancien établissement est remplacé par celui de ${t}.`,
  },
  {
    key: "bills",
    label: "Factures",
    icon: AccountBookOutlined,
    noun: ["facture", "factures"],
    records: true,
    what: t =>
      `chaque facture reste la même ; l'établissement facturé devient ${t}.`,
  },
  {
    key: "batches",
    label: "Lots de facturation",
    icon: ContainerOutlined,
    noun: ["lot", "lots"],
    records: true,
    what: t => `chaque lot de facturation est rattaché à ${t}.`,
  },
  {
    key: "principals",
    label: "Mandants",
    icon: FileTextOutlined,
    noun: ["mandant", "mandants"],
    records: true,
    what: t =>
      `chaque mandant lié à un ancien établissement pointe désormais vers ${t}.`,
  },
  {
    key: "billings",
    label: "Règles de facturation",
    icon: CalendarOutlined,
    noun: ["règle", "règles"],
    what: t =>
      `les règles de facturation mois par mois de chaque établissement deviennent une seule chronologie pour ${t}.`,
  },
];

export const sectionOf = key => SECTIONS.find(s => s.key === key);
